import type { SVGProps } from 'react';

const SvgVolumeOnMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M3 8.57143V15.4286H6L12 20V4L6 8.57143H3Z'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M16 10C16.3105 10.2329 16.5625 10.5348 16.7361 10.882C16.9096 11.2291 17 11.6119 17 12C17 12.3881 16.9096 12.7709 16.7361 13.118C16.5625 13.4652 16.3105 13.7671 16 14M19 7C19.6245 7.60261 20.1283 8.36438 20.4743 9.22951C20.8204 10.0947 21 11.0413 21 12C21 12.9587 20.8204 13.9053 20.4743 14.7705C20.1283 15.6356 19.6245 16.3974 19 17'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export default SvgVolumeOnMd;
